import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { CaseTypeData } from '@protocols/ui';

@Component({
    selector: 'ts-case-type-selection',
    templateUrl: './case-type-selection.component.html',
    styleUrls: ['./case-type-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatRippleModule, TranslateModule]
})
export class CaseTypeSelectionComponent {
  @Input() items: CaseTypeData[] = [];
  @Input() noCaseTypes = false;
  @Input() selectedCaseTypeId?: string;

  @Output() caseTypeSelected = new EventEmitter<CaseTypeData>();
}
